module.exports = __webpack_public_path__ + "static/media/check.0fcf1693.svg";